import { addToCartAndOpenDrawer } from '@theme/cart-quick-add';

/**
 * Collection-page product cards (quick-add popup disabled): the native add
 * button adds the selected size variant — or the first available one when none
 * is selected — and opens the cart drawer. Fully isolated: only reacts to
 * clicks on [data-collection-quick-add].
 */
document.addEventListener('click', async (event) => {
  if (!(event.target instanceof Element)) return;

  const button = event.target.closest('[data-collection-quick-add]');
  if (!button) return;

  event.preventDefault();

  const card = button.closest('.card-gallery');
  if (!card) return;

  // Selected size chip wins; otherwise fall back to the form's default variant
  // input, which holds product.selected_or_first_available_variant.
  const checkedSize = card.querySelector('.product-card__size-input:checked');
  const fallbackInput = card.querySelector('product-form-component input[name="id"]');
  const variantId = checkedSize?.dataset.variantId || fallbackInput?.value;

  if (!variantId) return;

  await addToCartAndOpenDrawer(variantId, { sourceId: 'collection-card-quick-add' });
});

document.addEventListener('change', async (event) => {
  if (!(event.target instanceof Element)) return;
  if (!event.target.matches('.product-card__size-input') || !event.target.checked) return;

  const productCard = event.target.closest('product-card');
  if (!productCard) return;

  if (productCard.getAttribute('data-size-add-mode') !== 'one-click') return;

  const variantId = event.target.dataset.variantId;
  if (!variantId) return;

  await addToCartAndOpenDrawer(variantId, { sourceId: 'collection-card-size-quick-add' });
});
